// extracted by mini-css-extract-plugin
module.exports = {"error":"style_error__zHIaq","note":"style_note__1Gj5U","titleContainer":"style_titleContainer__2rE1k","title":"style_title__21uYx","detailLink":"style_detailLink__3DPvZ"};